import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-number-field',
  templateUrl: './number-field.component.html',
  styleUrls: ['./number-field.component.scss']
})
export class NumberFieldComponent implements OnInit {

  @Input()
  value: number = 1;
  @Input()
  max: number|null = null;
  @Input()
  min: number = 1;
  @Input()
  step: number = 1;

  constructor() { }
  ngOnInit(): void {
  }

  decrement() {
    if(this.value > this.min) {
      this.value--
    }
  }
  increment() {
      if(this.max != null && this.max > this.value) {
        this.value++
      }
  }
}
